/* eslint-disable import/prefer-default-export */
import { get, post } from 'utils/methods';

export function getErrorsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}errors`, data, headers);
}

export function toggleErrorsStatusApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/error/status`, data, headers);
}
